export default "__VITE_ASSET__D5tvPh6E__"